import {Helmet} from 'react-helmet';
import AboutUs from "../../Page/aboutus";
import Testimonials from "../../Page/testimonials";
import Certificate from "../../Page/Certificate";

const faqsContent ={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Why should I hire a website designer in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Hiring a local web designer in Gurgaon ensures better communication, faster turnaround, and understanding of regional market trends."
      }
    },
    {
      "@type": "Question",
      "name": "What types of websites do you design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We design business websites, e-commerce stores, portfolio sites, blogs, and custom platforms tailored to your specific needs."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to complete a website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Most websites are completed within 2 to 4 weeks, depending on the design complexity and required features."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer SEO-friendly website design?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, all our websites are optimized for search engines with clean code, meta tags, schema, fast loading, and mobile responsiveness."
      }
    },
    {
      "@type": "Question",
      "name": "Will my website be mobile responsive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Absolutely. Every website we build is fully responsive and functions smoothly across all devices including smartphones and tablets."
      }
    },
    {
      "@type": "Question",
      "name": "Can I update my website on my own?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we usually use WordPress or other CMS platforms that allow easy editing of content, images, and blog posts."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide e-commerce website design in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we create robust e-commerce websites with secure payment gateways, product management, order tracking, and shipping integration."
      }
    },
    {
      "@type": "Question",
      "name": "What is the cost of a website in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Pricing starts at ₹10,000 for basic websites. E-commerce or custom projects may range from ₹25,000 to ₹1,00,000+ depending on scope."
      }
    },
    {
      "@type": "Question",
      "name": "Do you offer domain and hosting setup?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, we provide end-to-end support including domain name registration, reliable web hosting, and SSL setup."
      }
    },
    {
      "@type": "Question",
      "name": "How do I get started with your website design services in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact us via the website form or call us. We'll understand your needs, share a proposal, and begin the design process quickly."
      }
    }
  ]
}

function App1() {
  return (
   <>
 <Helmet>
  <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
    <title>Pankaj - Website Designer in Gurgaon</title>
  <meta name="description" content="Need a skilled website designer in Gurgaon? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites."/>
  <meta name="keywords" content="pankaj, website designer in gurgaon, website designing company in gurgaon, web designer in gurgaon, website design in gurgaon, website maker in gurgaon, web design company in gurugram, web design gurugram, web designer gurugram, web development company in gurugram, website development agency gurgaon"/>
<meta property="og:title" content="Pankaj - Website Designer in Gurgaon | website development company in gurgaon" />
<meta property="og:description" content="Need a skilled website designer in Gurgaon? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<meta property="og:site_name" content="Pankaj - Website Designer in Gurgaon | website development company in gurgaon" />
<meta property="og:url" content="https://www.pankj.com/website-designer-in-gurgaon"/>
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg"/>
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Pankaj - Website Designer in Gurgaon | website development company in gurgaon" />
<meta name="twitter:description" content="Need a skilled website designer in Gurgaon? Our team of experts can create stunning websites tailored to your business needs, from e-commerce to portfolio sites." />
<link rel="canonical" href="https://www.pankj.com/website-designer-in-gurgaon" />

        </Helmet>
 <section id="hero" className="hero d-flex align-items-center fixedabove">
<video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer1.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg campaignpage">
<div className="container-fluid">
<div className="row">
<div className="col-lg-7 d-flex flex-column order-xs-2 order-xs-1">
<img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
<div className="multiple_effects fzsml" id="text3d"><span className="offers"></span></div>
<div className="content_sec" data-aos="fade-up" data-aos-delay="400">If you are looking for a <h1 className="headerdesign">Website Designer in Gurgaon</h1>, then you are in the right place. Hello, I am pankaj with 10+ years of experience in website design & development. you can hire me as a freelancer for your dream projects.</div>
         <form action="https://www.pankj.com/php/campaign.php" method="post" className="php-email-form">
          <div className="claimnow"><i className="bi bi-gift"></i>&nbsp; Get a Website Today<strike>
       <i className="bi bi-currency-rupee"></i>10,000
    </strike> (<i className="bi bi-currency-rupee"></i>2,100 Only )<sup className="tcst"> T&C Apply*</sup></div>
              <div className="row gy-4">
                <div className="col-md-4 col-7">
                <input type="text" className="hiddenclasss" name="title" />
                  <input type="text" name="name" minLength="2" maxLength="20" id="name" className="form-control" placeholder="Your Name" required />
                </div>
                  <div className="col-md-3 col-5">
                  <input type="number" className="form-control" minLength="10" maxLength="13" name="phone" id="phone" placeholder="Your Phone" required />
                </div>
                <div className="col-md-5 col-sm-12 text-center mtss">
                  <input type="submit" className="form-control submitbtn" name="submit" placeholder="Submit" value="Claim Now(₹2100)Only*" onclick="return SubmitDetails();" />
                </div>

              </div>
            </form>
</div>
<div className="col-lg-5 hero-img order-xs-1 order-md-2" data-aos="zoom-out" data-aos-delay="200">
<div className="wrapper">
<div className="img-area">
<div className="inner-area">
<div className="bgimg"></div>
</div>
</div>

</div>
</div>

</div>
</div> 

</div>
</section> 

    <main id="main">
 <AboutUs />
<Testimonials/>
<Certificate />
</main>
    </>
  );
}
export default App1;
